import React from "react";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  Tooltip,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { TabHeader } from "../../components/profile/accountInformation/TabHeader";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import { PAYMENT_HISTORY_TABLE_HEADERS } from "../../constant/TableHeaders";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const rows = [
  {
    id: 1,
    payment_id: "PAY123456789",
    invoice_id: "INV987654321",
    service: "Cleaning",
    title: "Monthly Service Fee",
    paid_at: "2025-10-01 12:30 PM",
    amount: "50.00 USD",
  },
  {
    id: 2,
    payment_id: "PAY987654321",
    invoice_id: "INV123456789",
    service: "Maintenance",
    title: "Plumbing Repair",
    paid_at: "2025-09-25 03:45 PM",
    amount: "150.00 USD",
  },
  {
    id: 3,
    payment_id: "PAY564738291",
    invoice_id: "INV564738291",
    service: "Rent",
    title: "Monthly Rent - September",
    paid_at: "2025-09-01 10:00 AM",
    amount: "1200.00 USD",
  },
  {
    id: 4,
    payment_id: "PAY192837465",
    invoice_id: "INV192837465",
    service: "Security",
    title: "Security Fee for August",
    paid_at: "2025-08-15 02:15 PM",
    amount: "75.00 USD",
  },
  {
    id: 5,
    payment_id: "PAY786543210",
    invoice_id: "INV786543210",
    service: "Cleaning",
    title: "Deep Cleaning - Special Request",
    paid_at: "2025-07-30 11:00 AM",
    amount: "200.00 USD",
  },
];

export const PaymentHistory = ({ userDetails }) => {
  return (
    <>
      {/* Header */}
      <TabHeader
        title="Payment History"
        breadcrumb="Profile - Payment History"
        IconComponent={HomeIcon}
      />

      {/* Personal Information */}
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          overflow: "hidden",
          mt: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            p: 2,
          }}
        >
          <TableContainer>
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <TableHeaderRow>
                  {PAYMENT_HISTORY_TABLE_HEADERS.map((item, index) => (
                    <TableCell
                      key={index}
                      align={item.alignItemTo}
                      sx={{ width: item.width }}
                    >
                      {item.title}
                    </TableCell>
                  ))}
                </TableHeaderRow>
              </TableHead>

              <StyledTableBody>
                {rows.map((row) => (
                  <TableBodyRow
                    key={row.id}
                    hover
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                  >
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.payment_id}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.invoice_id}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.service}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.title}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.paid_at}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {row.amount}
                    </TableCell>
                    <TableCell sx={{ width: 150, alignItemTo: "left" }}>
                      <Tooltip title="Download" arrow>
                        <IconButton
                          //onClick={() => handleViewClick(row)}
                          size="small"
                        >
                          <FileDownloadOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableBodyRow>
                ))}
              </StyledTableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </>
  );
};
